<BasePersona :target-personas="[sharedDataService.Personas.ANONYMOUS]" >
  <slot></slot>
</BasePersona>